import { Helper } from '../Helper';
export class DeleteStorageHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitOp(node, 'DUP');
            sb.emitHelper(node, options, sb.helpers.getStorage);
            sb.emitHelper(node, options, sb.helpers.handleUndefinedStorage({
                handleUndefined: () => {
                    sb.emitOp(node, 'DROP');
                    sb.emitPushBoolean(node, false);
                },
                handleDefined: () => {
                    sb.emitOp(node, 'DROP');
                    sb.emitHelper(node, options, sb.helpers.deleteStorageBase);
                    sb.emitPushBoolean(node, true);
                },
            }));
        }
        else {
            sb.emitHelper(node, options, sb.helpers.deleteStorageBase);
        }
    }
}

//# sourceMappingURL=DeleteStorageHelper.js.map
